import React from 'react';
import { useNavigate } from 'react-router-dom';
import blogPosts from '../data/blogPosts';

const Writing = () => {
  const navigate = useNavigate();
  // Show up to 3 featured posts on the landing page
  const featured = blogPosts.slice(0, 3);

  return (
    <section className="writing section" id="writing">
      <div className="container">
        {/* Section header */}
        <div className="writing__header">
          <h2 className="section__title-1">
            <span>Writing</span>
          </h2>
          <p className="writing__desc">
            Long-form articles on AI research, systems I've built, and the
            thinking behind the work.
          </p>
        </div>

        {/* Post cards */}
        <div className="writing__grid">
          {featured.map((post) => (
            <div
              key={post.id}
              className="writing__card"
              onClick={() => navigate(`/blog/${post.slug}`)}
              role="link"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === 'Enter' && navigate(`/blog/${post.slug}`)
              }
              aria-label={`Read: ${post.title}`}
            >
              <div className="writing__card-top">
                <span className="writing__series-tag">{post.seriesTag}</span>
                <div className="writing__card-arrow">
                  <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                </div>
              </div>
              <h3 className="writing__card-title">{post.title}</h3>
              <p className="writing__card-subtitle">{post.subtitle}</p>
              <div className="writing__card-footer">
                <span className="writing__meta">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {post.readTime}
                </span>
                <div className="writing__tags">
                  {post.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="writing__tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="writing__cta">
          <button
            className="button"
            onClick={() => navigate('/blog')}
          >
            View All Articles
            <i className="ri-arrow-right-line button-icon"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Writing;
